module.exports = __webpack_public_path__ + "media/tronos2019.5da475eb.mp4";